import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { gql, Resolver, InMemoryCache, DocumentNode } from '@apollo/client';

import { GET_SESSION_IS_VALID } from './getSessionIsValid';

export interface Args {
    clientId: string;
    userPoolId: string;
}

interface SignOutWithCognitoContext {
    cache: InMemoryCache;
    initialStateData?: Record<string, unknown>;
    initialStateQuery?: DocumentNode;
}

export const signOutWithCognito: Resolver = async (
    obj: Record<string, unknown>,
    args: Args,
    context: SignOutWithCognitoContext,
): Promise<CognitoActionResult> => {
    const { cache, initialStateData, initialStateQuery } = context;
    const { clientId, userPoolId } = args;

    const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: clientId,
    });

    const getUserAndSignOut = (): Promise<CognitoActionResult> =>
        new Promise(resolve => {
            const cognitoUser = userPool.getCurrentUser();

            if (initialStateData && initialStateQuery) {
                // If initialStateData && initialStateQuery are in context, use them to reset the cache
                cache.writeQuery({
                    data: initialStateData,
                    query: initialStateQuery,
                });
            } else {
                // Otherwise, invalidate the session only
                cache.writeQuery({
                    query: GET_SESSION_IS_VALID,
                    data: {
                        session: {
                            sessionIsValid: false,
                            __typename: 'Session',
                        },
                    },
                });
            }

            if (cognitoUser === null) {
                resolve({ success: false });
            } else {
                cognitoUser.signOut();
                resolve({ success: true });
            }
        });

    return getUserAndSignOut();
};

export const SIGN_OUT_WITH_COGNITO = gql`
    mutation SignOutWithCognito($clientId: String, $userPoolId: String) {
        signOutWithCognito(clientId: $clientId, userPoolId: $userPoolId) @client
    }
`;
